import {
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  OverlayDrawer,
  Button,
  DrawerFooter,
  makeStyles,
} from "@fluentui/react-components";
import { DismissRegular, FilterRegular } from "@fluentui/react-icons";
import * as React from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";

import { useSelector } from "@tdp/core";
import { IAnalyticsV2Filters, analyticsFilterSlice } from '@tdp/modules/apps';

import { FilterDrawerCheckBoxes } from "./FilterDrawer";

const useFilterButtonStyles = makeStyles({
  filterButton: {
    marginRight: "10px",
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 'auto',
  }
})

export const FilterButton: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const styles = useFilterButtonStyles();
  const [isOpen, setIsOpen] = React.useState(false);
  const filter: IAnalyticsV2Filters = useSelector((state) => state.analyticsFilter.filters);
  const [selectedFilters, setSelectedFilters] = React.useState<IAnalyticsV2Filters>(filter);

  const onSaved = () => {
    dispatch(analyticsFilterSlice.actions.updatedAnalyticsFilter(selectedFilters));
    setIsOpen(false);
  }

  const title = intl.formatMessage({
    defaultMessage: "Filter",
    description: "Title for the filter dialog in the analytics page"
  });

  const save = intl.formatMessage({
    defaultMessage: "Save",
    description: "Save button text on filter"
  });

  React.useEffect(() => {
    setSelectedFilters(filter);
  }, [filter]);

  return (
    <>
      <OverlayDrawer
        modalType="non-modal"
        position="end"
        open={isOpen}
        onOpenChange={(_, { open }) => { setIsOpen(open); }}
      >
        <DrawerHeader>
          <DrawerHeaderTitle
            action={
              <Button
                appearance="subtle"
                icon={<DismissRegular />}
                onClick={() => {
                  setSelectedFilters(filter);
                  setIsOpen(false);
                }}
              />
            }
          >
            {title}
          </DrawerHeaderTitle>
        </DrawerHeader>
        <DrawerBody>
          <FilterDrawerCheckBoxes selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} />
        </DrawerBody>
        <DrawerFooter>
          <Button appearance="primary" onClick={() => { onSaved(); }}>{save}</Button>
        </DrawerFooter>
      </OverlayDrawer>
      <Button
        className={styles.filterButton}
        appearance="outline" icon={<FilterRegular />} onClick={() => { setIsOpen(!isOpen); }}>
        {title}
      </Button>
    </>
  );
};
